// removed by extract-text-webpack-plugin
module.exports = {"SearchItem":"styles__SearchItem___Zt2mT","SubTitle":"styles__SubTitle___AZ0zb","Subregion":"styles__Subregion___1r1WU","Address":"styles__Address___2ZPio","Input":"styles__Input___1r8WC","Menu":"styles__Menu___5RgyM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Search/SearchItem/styles.scss
// module id = 1351
// module chunks = 0